import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const buttonList = store.getters && store.getters.buttonList
    if (value && value instanceof Array && value.length > 0) {
      const hasPermission = value.some(permission => buttonList.indexOf(permission) !== -1)
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`使用方式： v-permission-dropdown="['permission1', 'permission2']"`)
    }
  }
}
